// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__reAfm","paramInput":"JobSimulator_paramInput__JlDrj","input":"JobSimulator_input__3m5ZT"};